module.exports = __webpack_public_path__ + "static/assets/0f9efe3bd6e80747dfa3aeb9e19997b5.svg";